
import { z } from "zod";

export const PhotoReviewAttemptTypeValues = ["ACCEPT", "REQUEST"] as const;
export const PhotoReviewAttemptTypeSchema = z.enum(PhotoReviewAttemptTypeValues);
export const PhotoReviewAttemptType = PhotoReviewAttemptTypeSchema.enum;
export type PhotoReviewAttemptType = (typeof PhotoReviewAttemptTypeValues)[number];
